export default __webpack_public_path__ + "static/media/five.81ac59a6.jpg";